import apiClient from './client';
import type { FeatureCatalogEntry } from '../types/auth';

// Feature 011 — exposes the rich-object catalog slice for the current caller
// (FR-016). Editor → granted entries; Admin → full active catalog;
// Public User → [].
export const meApi = {
  getAccessibleFeatures: async (): Promise<FeatureCatalogEntry[]> => {
    const response = await apiClient.get<FeatureCatalogEntry[]>('/me/features');
    return response.data;
  },
};
